import {
  globalAxios,
  backendVersion,
  managerInstance,
  merchantInstance,
  axiosPath,
} from "@/axios-path.js";
import axios from "axios";

export default {
  namespaced: true,
  state: {
    businessListData: [],
    businessDetail: {
      company_provider_wesmart_bank: {},
      company_provider_wesmart_customer_id_card: {},
      company_provider_wesmart_juristic_id: {},
      company_provider_wesmart_provider: {},
      company_provider_wesmart_district: {},
      company_provider_wesmart_sub_district: {},
      company_provider_wesmart_zipcode: {},
      company_provider_wesmart_user: {},
    },
    businessClient: [],
    transaction: [],
    actionlog: [],
    monitor_list: [],
  },
  mutations: {
    setBusinesslist(state, data) {
      state.businessListData = data;
    },
    setBusinesslistDetail(state, data) {
      state.businessDetail = data;
    },
    setBusinessClient(state, data) {
      state.businessClient = data;
    },
    setTransaction(state, data) {
      state.transaction = data;
    },
    setActionlog(state, data) {
      state.actionlog = data;
    },
    setMonitor(state, data) {
      state.monitor_list = data;
    },
  },
  actions: {
    async fetchBusinesslist({ commit }, id) {
      let url =
        backendVersion.version +
        "/weserve_for_business/backoffice/manage_company_info";
      return managerInstance
        .get(url)
        .then((res) => {
          if (res.msg == false) return false;
          commit("setBusinesslist", res.data);
          return res.data;
        })
        .catch((err) => {
          return [];
        });
    },
    async fetchActionLog({ commit }, id) {
      let url =
        backendVersion.version +
        "/weserve_for_business/get_action_log_provider_wesmart_backoffice";
      return managerInstance
        .get(url)
        .then((res) => {
          if (res.msg == false) return false;
          commit("setActionlog", res.data);
          return res.data;
        })
        .catch((err) => {
          return [];
        });
    },
    async fetchBusinesslist_client({ commit }) {
      let url =
        backendVersion.version +
        "/weserve_for_business/get_list_user_provider_wesmart_backoffice";
      return managerInstance
        .get(url)
        .then((res) => {
          if (res.msg == false) return false;
          commit("setBusinessClient", res.data);
        })
        .catch((err) => {
          return false;
        });
    },
    async fetchTransactionByUser({ commit }, id) {
      let url =
        backendVersion.version +
        "/weserve_for_business/get_transaction_by_user_provider_wesmart_backoffice/" +
        id;
      return managerInstance
        .get(url)
        .then((res) => {
          if (res.msg == false) return false;
          commit("setTransaction", res.data);
        })
        .catch((err) => {
          return false;
        });
    },
    async fetchBusinesslistDetail({ commit }, id) {
      let url =
        backendVersion.version +
        "/weserve_for_business/get_business_detail_backoffice/" +
        id;
      return managerInstance
        .get(url)
        .then((res) => {
          if (res.msg == false) return false;
          commit("setBusinesslistDetail", res.data);
          return res.data;
        })
        .catch((err) => {
          return [];
        });
    },
    async ApproveRejectBusiness({ commit, dispatch }, payload) {
      let url =
        backendVersion.version +
        "/weserve_for_business/approve_reject_business_provider_wesmart_backoffice";
      return globalAxios
        .post(url, payload)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return false;
        });
    },

    async deleteBankManagerBackoffice({ commit, dispatch }, item) {
      let url = `${backendVersion.version
        }/partner/delete_bank_manager_backoffice/${item}`;
      return managerInstance
        .delete(url)
        .then((res) => {
          if (res.msg == false) return false;
          return res.data;
        })
        .catch(() => {
          return false;
        });
    },
    async RejectBankManager({ commit, dispatch }, { payload }) {
      let url = backendVersion.version + "/partner/reject_bank_manager";
      const remark = {
        bank_manager_id: payload.id,
        remark: payload.remark,
      };
      return managerInstance
        .delete(url, {
          data: remark,
        })
        .then((res) => {
          if (res.msg == false) return false;
          return res.data;
        })
        .catch(() => {
          return false;
        });
    },
    async getMonitor_invoice({ commit }) {
      // let url = backendVersion.version + "/partner/reject_bank_manager";
      // const remark = {
      //   bank_manager_id: payload.id,
      //   remark: payload.remark,
      // };
      // return managerInstance
      //   .delete(url, {
      //     data: remark,
      //   })
      //   .then((res) => {
      //     if (res.msg == false) return false;
      //     return res.data;
      //   })
      //   .catch(() => {
      //     return false;
      //   });
      let a = [
        {
          no: "1",
          date: 1688963577,
          duedate: 1688963577,
          owner: "บาส",
          invoice: "12532533622",
          type: "ใบแจ้งหนี้",
          discription: "ทดสอบ",
          net: 1250,
          status: 1,
        },
        {
          no: "2",
          date: 1688963577,
          duedate: 1688963577,
          owner: "บาส",
          invoice: "12532533622",
          type: "ใบแจ้งหนี้",
          discription: "ทดสอบ",
          net: 1250,
          status: 3,
        },
      ];
      commit("setMonitor", a);
    },
    async createBusiness({ commit }, payload) {
      let url = backendVersion.version + "/weserve_for_business/backoffice/manage_company_info";
      return globalAxios
        .post(url, payload)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return err.response.data
        });
    },
    async updateBusiness({ commit }, payload) {
      let url = backendVersion.version + "/weserve_for_business/backoffice/manage_company_info";
      return globalAxios
        .put(url, payload)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return err.response.data;
        });
    },
    async deleteBusiness({ commit }, payload) {
      let url = `${backendVersion.version}/weserve_for_business/backoffice/manage_company_info?company_id=${payload.company_id}`;
      return globalAxios
        .delete(url)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return err.response.data
        });
    },
  },
  getters: {},
};
